import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { QA_NAME_SAVE_BTN } from '../../../constants/qa'

export const REQUEST_EDIT_USER_MODAL_FORM_BODY_PROPS = {
  ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
  submitQaName: QA_NAME_SAVE_BTN,
}
